import React, { useEffect, useState } from "react";
import { Flame, ArrowRight, X } from "lucide-react";

const STORAGE_KEY = "iariya_promo_bar_dismissed";

export const PromoBar = () => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === "1";
    } catch {
      return false;
    }
  });

  // Show after the user has scrolled past the hero
  useEffect(() => {
    if (dismissed) return;
    const threshold = 600;
    const onScroll = () => setVisible(window.scrollY > threshold);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [dismissed]);

  // Sync CSS variable so the Nav can sit beneath the bar without overlap
  useEffect(() => {
    const height = visible && !dismissed ? "52px" : "0px";
    document.documentElement.style.setProperty("--promo-bar-h", height);
    return () => {
      document.documentElement.style.setProperty("--promo-bar-h", "0px");
    };
  }, [visible, dismissed]);

  const close = () => {
    setDismissed(true);
    try {
      sessionStorage.setItem(STORAGE_KEY, "1");
    } catch {
      /* noop */
    }
  };

  if (dismissed) return null;

  return (
    <div
      data-testid="promo-bar"
      className={`fixed inset-x-0 top-0 z-[60] transition-transform duration-300 ease-out ${
        visible ? "translate-y-0" : "-translate-y-full"
      }`}
      aria-hidden={!visible}
    >
      <div className="bg-[var(--ink)] text-white border-b-2 border-[var(--yellow)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-[52px] flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 min-w-0">
            <div className="hidden sm:flex h-8 w-8 shrink-0 rounded-lg border-2 border-white/30 bg-[var(--pink)] items-center justify-center">
              <Flame size={16} className="text-white" />
            </div>
            <p
              className="text-sm sm:text-base font-bold truncate"
              data-testid="promo-bar-text"
            >
              <span className="text-[var(--yellow)]">Half-price launch</span>{" "}
              promo
              <span className="hidden md:inline text-white/85">
                {" "}
                — lock in the lifetime rate today.
              </span>
            </p>
          </div>

          <div className="flex items-center gap-2 shrink-0">
            <a
              href="#book"
              data-testid="promo-bar-cta"
              className="inline-flex items-center gap-1.5 bg-[var(--yellow)] text-ink border-2 border-ink rounded-full px-3 sm:px-4 py-1.5 text-sm font-black shadow-[3px_3px_0_0_#1c1917] hover:translate-y-[-1px] hover:translate-x-[-1px] hover:shadow-[5px_5px_0_0_#1c1917] transition"
            >
              Claim now <ArrowRight size={14} />
            </a>
            <button
              onClick={close}
              data-testid="promo-bar-dismiss"
              className="h-8 w-8 rounded-full border-2 border-white/30 hover:bg-white/15 flex items-center justify-center"
              aria-label="Dismiss promo"
            >
              <X size={14} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
